import { ForwardedRef, forwardRef } from 'react';
import { clsx } from '@team/clsx';
import { Clickable, ClickableModel } from '../clickable';
import { Props } from './types';
import { DEFAULT_STATE_MODE } from './const';
import {
  detectTypeProps,
  getActiveClassNameByStateMode,
  getHoverClassNameByStateMode,
  shouldMountEffectElement,
} from './model';
import css from './style.module.css';

export const Entry = forwardRef(function Tappable(
  {
    baseClassName,
    hoverMode = DEFAULT_STATE_MODE,
    activeMode = DEFAULT_STATE_MODE,
    children,
    ...props
  }: Props,
  forwardedRef: ForwardedRef<HTMLElement>
) {
  const hasState =
    ClickableModel.isInteractive(props) &&
    shouldMountEffectElement(hoverMode, activeMode);
  const typeProps = detectTypeProps(props);

  return (
    <Clickable
      {...typeProps}
      {...props}
      baseClassName={clsx(baseClassName, css.root)}
      hoverClassName={getHoverClassNameByStateMode(hoverMode)}
      activeClassName={getActiveClassNameByStateMode(activeMode)}
      ref={forwardedRef}
    >
      {children}

      {hasState && <span className={css.state} aria-hidden />}
    </Clickable>
  );
});
